export const useQueryParams = () => {
  if (typeof window === "undefined") {
    return new URLSearchParams("");
  }
  return new URLSearchParams(window.location.search);
};
